module.exports = __webpack_public_path__ + "static/media/bracket-right-top-05.a337b989.svg";